import CircularProgress from '@mui/material/CircularProgress';
import MenuItem from '@mui/material/MenuItem';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import useAsyncGetApTemplates from '../../../../hooks/useAsyncGetApTemplates';
import { RequestStatus } from '../../../../sic-lib/enums/RequestStatus';
import { ApTemplate } from '../../../../sic-lib/types/ApTemplate';

const useStyles = makeStyles()({
    textField: {
        minWidth: '18ch',
    },
    loadingItem: {
        display: 'flex',
        justifyContent: 'center',
        '& .Mui-disabled': {
            opacity: 0,
        },
    },
});

type Props = TextFieldProps & {
    onSelectHandler: React.Dispatch<{ templateId: number }>;
    className?: string;
};

export default function SelectApTemplate({ onSelectHandler, className, ...props }: Props) {
    const { classes, cx } = useStyles();

    const { requestStatus, asyncGetApTemplates } = useAsyncGetApTemplates();

    const [templates, setTemplates] = React.useState<ApTemplate[]>([]);

    React.useEffect(() => {
        async function request() {
            const asyncResult = await asyncGetApTemplates();

            if (asyncResult) {
                setTemplates(asyncResult);
            }
        }

        request();
    }, []);

    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        onSelectHandler({ templateId: +event.target.value });
    };

    return (
        <TextField
            {...(props as TextFieldProps)}
            select
            id={props.id || 'select_ap_template'}
            name={props.name || 'select_ap_template'}
            label={props.label || 'Select Template'}
            onChange={handleSelect}
            className={cx(classes.textField, className && className)}
        >
            {requestStatus === RequestStatus.active && (
                <MenuItem disabled={true} className={classes.loadingItem}>
                    <CircularProgress size={24} />
                </MenuItem>
            )}
            {requestStatus === RequestStatus.success &&
                templates.map(tmp => (
                    <MenuItem key={tmp.templateId} value={tmp.templateId}>
                        {tmp.title}
                    </MenuItem>
                ))}
        </TextField>
    );
}
